import axios from 'config/axios';

const prefix = 'sidebar';

export default class SideMenuSrv {
  static get() {
    return axios.get(`${prefix}`).then(result => result.data);
  }
}
